import useBreakpoint from "antd/es/grid/hooks/useBreakpoint"
import { FC, ReactNode } from "react"

import classnames from "classnames"
import Typography, { Size } from "../typography/Typography"
import "./FormItemDivider.less"

const { Text, Title } = Typography
type Props = {
  label?: string | ReactNode
  subTitle?: Maybe<string> | ReactNode
  marginTop?: string | number
  marginBottom?: string | number
  textAlign?: "left" | "right" | "center" | "justify" | "start" | "end"
  title?: string | ReactNode
  titleLevel?: 1 | 2 | 3 | 4 | 5
  subtitleSize?: Size
  extra?: React.ReactNode
  variant?: "default" | "black"
}
const FormItemDivider: FC<Props> = ({
  extra,
  titleLevel = 3,
  subtitleSize = "sm",
  label,
  textAlign,
  marginBottom = 10,
  marginTop = 8,
  subTitle,
  title,
  variant = "default",
}) => {
  const { xxl, xl, lg, md } = useBreakpoint()
  const labelClasses = classnames({
    "label-wrapper": true,
    "variant-black": variant === "black",
  })

  return (
    <div
      className={"form-sub-title-divider"}
      style={{
        marginTop: Number(marginTop),
        marginBottom: Number(marginBottom),
        textAlign: textAlign,
      }}
    >
      <div className={labelClasses}>
        <div className={"label-container"}>
          {label && (
            <Text weight={"w700"} size={!(xxl || xl || lg || md) ? "sm" : "md"}>
              {label}
            </Text>
          )}
          {title && (
            <Title style={{ marginBottom: 0 }} level={!(xxl || xl || lg || md) ? 4 : titleLevel}>
              {title}
            </Title>
          )}
        </div>
        {extra && <div className={"extra-wrapper"}>{extra}</div>}
      </div>

      {subTitle &&
        (typeof subTitle === "string" ? (
          <Text
            weight={"w400"}
            size={subtitleSize}
            className={"sub-title"}
            color={variant === "black" ? "black" : "gray"}
          >
            {subTitle}
          </Text>
        ) : (
          <div className={"sub-title"}>{subTitle}</div>
        ))}
    </div>
  )
}

export default FormItemDivider
